import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Lock, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";

const NAV = [
  { label: "Program", id: "program" },
  { label: "Impact", id: "impact" },
  { label: "The Book", id: "book" },
  { label: "Speaking", id: "speaking" },
  { label: "Endorsements", id: "testimonials" },
];

export const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-[#0D0E11]/85 backdrop-blur-xl" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} data-testid="header-logo-link">
          <Logo />
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => scrollToId(n.id)} className="text-sm text-[#9CA3AF] hover:text-amber-500 transition-colors" data-testid={`nav-${n.id}`}>
              {n.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <Link to="/admin/login" className="text-[#6B7280] hover:text-amber-500 transition-colors" title="Admin portal" data-testid="admin-portal-link">
            <Lock size={16} />
          </Link>
          <button onClick={() => scrollToId("inquiry")} className="hidden sm:inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-[#0D0E11] font-semibold text-sm px-5 py-2.5 rounded-full transition-colors" data-testid="header-book-training-btn">
            Book a Training <ArrowUpRight size={16} />
          </button>
          <button className="lg:hidden text-[#F3F4F6]" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0D0E11] px-6 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => { setOpen(false); scrollToId(n.id); }} className="text-left text-[#9CA3AF] py-1" data-testid={`mobile-nav-${n.id}`}>
              {n.label}
            </button>
          ))}
          <button onClick={() => { setOpen(false); scrollToId("inquiry"); }} className="text-left text-amber-500 font-semibold" data-testid="mobile-book-training-btn">
            Book a Training
          </button>
        </div>
      )}
    </header>
  );
}
